import axios from 'axios';
import configDb from "../config";
import { store, authActions } from "../store";
import ConfigDB from "../config";

const API_URL = configDb.data.api_url;

const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        accept: '*/*',
    },
});

axiosInstance.interceptors.request.use((config) => {
    let auth = store.getState().auth.value;
    let lngData = localStorage.getItem("lng")
    if (typeof auth !== "object") {
        auth = JSON.parse(auth);
    }

    if (auth?.access_token) {
        config.headers.auth = auth.access_token;
        config.headers.lg= lngData
        // if (auth?.main_branch && auth?.main_branch > 0) {
        //     config.headers.branch = auth.main_branch;
        // }
    }


    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    }

    return config;
});

// ─────────────────────────────────────────────────────────────
// Response interceptor — lida com:
//   401 SESSION_REVOKED | SESSION_LEGACY | TOKEN_INVALID | USER_INACTIVE
//     → logout local + redirect /login
//   402 SUBSCRIPTION_EXPIRED | ACCOUNT_BLOCKED | SUBSCRIPTION_UNPAID
//     → expõe em window.__tpAccountBlocked para os componentes reagirem
//     → redirect /subscription (excepto se já lá estiver)
// ─────────────────────────────────────────────────────────────

const LOGOUT_CODES = new Set([
    "SESSION_REVOKED",
    "SESSION_LEGACY",
    "TOKEN_INVALID",
    "USER_INACTIVE",
    "NO_TOKEN",
    "USER_NOT_FOUND",
]);
const BLOCKED_CODES = new Set([
    "SUBSCRIPTION_EXPIRED",
    "ACCOUNT_BLOCKED",
    "SUBSCRIPTION_UNPAID",
]);

function _hardLogout() {
    try {
        localStorage.removeItem(ConfigDB?.data?.login_data);
        localStorage.removeItem("@secure.@data");
        store.dispatch(authActions.setAuth(null));
    } catch (e) {
        // ignore
    }
    if (!/\/(login|signup|forgot-password|reset-password|terms-condition|privacy-policy|faq|api-docs|^\/$)/.test(window.location.pathname)) {
        window.location.replace("/login?reason=session_revoked");
    }
}

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const code = error?.response?.data?.code;
        const message = error?.response?.data?.message;

        // 401 → sessão terminada, fazer logout limpo
        if (status === 401 && code && LOGOUT_CODES.has(code)) {
            _hardLogout();
            return Promise.reject(error);
        }

        // 402 → conta bloqueada/expirada. Expõe no window + redirect.
        if (status === 402 && code && BLOCKED_CODES.has(code)) {
            try {
                window.__tpAccountBlocked = {
                    code,
                    message,
                    data: error.response.data?.data,
                    at: Date.now(),
                };
            } catch (e) { /* ignore */ }
            // Notifica o resto da app via evento custom
            try {
                window.dispatchEvent(new CustomEvent("tp:accountBlocked", {
                    detail: { code, message, data: error.response.data?.data },
                }));
            } catch (e) { /* ignore */ }

            // Evita loop se já estamos na página de subscrição
            const path = window.location.pathname || "";
            const isOnAllowed = /^\/(subscription|profile|login|logout)/.test(path);
            if (!isOnAllowed) {
                window.location.replace("/subscription?blocked=1&code=" + encodeURIComponent(code));
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
